import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  downloadStarted: 'Download will commence shortly.',
  downloadFailed: 'Export failed. Please try again.',
})
